module.exports = __webpack_public_path__ + "static/media/vbtn_2x.496011e0.png";